import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Instagram } from 'lucide-react';
import { panelPath } from '../../config/paths';

export default function NoAccountState() {
  const { t } = useTranslation();
  return (
    <div className="card border-dashed p-10 text-center">
      <span className="icon-chip mx-auto">
        <Instagram className="h-5 w-5" />
      </span>
      <p className="mt-4 text-gray-500 dark:text-lc-muted">{t('common.connectAccountFirst')}</p>
      <Link to={panelPath('/accounts')} className="btn-primary mt-4 inline-flex">
        {t('accounts.title')}
      </Link>
    </div>
  );
}
